module.exports = __webpack_public_path__ + "img/bb.6e659ff2.svg";